// Ordered [key, label] rows for the Schedule Property two-column table.
// Keep in sync with SCHEDULE_ATTR_ROWS in backend/server.py
export const SCHEDULE_ATTR_ROWS = [
  ['sy_no', 'Sy. No.'],
  ['extent', 'Extent of Land'],
  ['conversion_status', 'Status of Conversion'],
  ['zoning', 'Zoning Regulations'],
  ['abutting_nala', 'Abutting to Nala'],
  ['land_origin', 'Land Origin Type'],
  ['title_traced_from', 'Title Traced From'],
  ['tenancy_rights', 'Tenancy Rights'],
  ['pending_litigation', 'Pending Litigation'],
  ['lease_hold', 'Lease Hold Rights'],
  ['mortgage_charge', 'Mortgage/Charge'],
  ['land_acquisition', 'Land Acquisition'],
  ['present_owner', 'Present Owner/Khatedar'],
  ['parties_to_deed', 'Parties to the Deed/Agreement'],
  ['encumbrance_created', 'Any Encumbrance Created'],
  ['major_concern', 'Any Major Concern on Title'],
];

export const SCHEDULE_BOUNDARIES = [
  ['east_by', 'East By'],
  ['west_by', 'West By'],
  ['north_by', 'North By'],
  ['south_by', 'South By'],
];

export const emptyScheduleItem = () => ({
  description: '',
  east_by: '', west_by: '', north_by: '', south_by: '',
  ...Object.fromEntries(SCHEDULE_ATTR_ROWS.map(([k]) => [k, ''])),
});
